import React from 'react'
import { AppData, ModuleData } from '../../types/appTypes'
import MobileTopbar from './MobileTopbar';
import MobileCardView from '../content/MobileCardView';


type Props = { data: ModuleData[] };

const MobileLayout: React.FC<Props> = ({ data }) => {
    return (
        <>
            <MobileTopbar />
            <MobileCardView data={data} />
        </>
    )
}

export default MobileLayout